var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPortfolioCongIcons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 16.4C11.6974 16.4 13.3253 15.7257 14.5255 14.5255C15.7257 13.3253 16.4 11.6974 16.4 10C16.4 8.30261 15.7257 6.67475 14.5255 5.47452C13.3253 4.27428 11.6974 3.6 10 3.6M10 16.4C8.30261 16.4 6.67475 15.7257 5.47452 14.5255C4.27428 13.3253 3.6 11.6974 3.6 10M10 16.4V18M10 3.6C8.30261 3.6 6.67475 4.27428 5.47452 5.47452C4.27428 6.67475 3.6 8.30261 3.6 10M10 3.6V2M3.6 10H2M11.6 10C11.6 10.4243 11.4314 10.8313 11.1314 11.1314C10.8313 11.4314 10.4243 11.6 10 11.6C9.57565 11.6 9.16869 11.4314 8.86863 11.1314C8.56857 10.8313 8.4 10.4243 8.4 10C8.4 9.57565 8.56857 9.16869 8.86863 8.86863C9.16869 8.56857 9.57565 8.4 10 8.4C10.4243 8.4 10.8313 8.56857 11.1314 8.86863C11.4314 9.16869 11.6 9.57565 11.6 10ZM11.6 10H18M14 16.928L13.2 15.544M9.2 8.616L6 3.072M16.928 14L15.544 13.2M3.072 6L4.456 6.8M16.928 6L15.544 6.8M3.072 14L4.456 13.2M14 3.072L13.2 4.456M9.2 11.384L6 16.928",
    stroke: "#33363F",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortfolioCongIcons);
export default __webpack_public_path__ + "static/media/portfolioCongIcons.edb2e8c2f0e3fae7196cca4a2fa45816.svg";
export { ForwardRef as ReactComponent };